import { useEffect, useState } from "react";

import { api } from "../api/client";
import type { Me } from "../types";

type UseCurrentUserResult = {
  user: Me | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
};

export function useCurrentUser(): UseCurrentUserResult {
  const [user, setUser] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  async function fetchUser() {
    setLoading(true);
    setError(null);
    const result = await api.GET("/api/me");
    if (result.error) {
      setError("Nie udało się pobrać danych użytkownika.");
      setLoading(false);
      return;
    }
    setUser(result.data as Me);
    setLoading(false);
  }

  useEffect(() => {
    void fetchUser();
  }, []);

  return {
    user,
    loading,
    error,
    refetch: fetchUser,
  };
}
